import React from 'react';
import styled from 'styled-components';
import { BrowserRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LastLocationProvider } from 'react-router-last-location';

// Routes
import AppRoutes from 'components/routes/app_routes/AppRoutes';

// Templates
import { SubscriberTemplate, AppTemplate } from 'components/templates';

// Layout
import Header from 'components/layout/header/Header';
import Footer from 'components/layout/footer/Footer';

// Import utilities
import useViewport from 'components/utilities/hooks/useViewport';

// Import styles
import { contentMinHeight } from 'components/styles';

const App = () => {
	const { i18n } = useTranslation();
	useViewport();

	return (
		<BrowserRouter basename={i18n.language}>
			<LastLocationProvider>
				<SubscriberTemplate>
					<AppTemplate>
						<Header />
						<Wrapper>
							<AppRoutes />
						</Wrapper>
						<Footer />
					</AppTemplate>
				</SubscriberTemplate>
			</LastLocationProvider>
		</BrowserRouter>
	);
};

const Wrapper = styled.div`
	${contentMinHeight}
	flex: 1;
	display: flex;
	flex-direction: column;
`;

export default React.memo(App);
